import { render, staticRenderFns } from "./WholesaleCustomerInfo.vue?vue&type=template&id=401ddfe9&scoped=true"
import script from "./WholesaleCustomerInfo.vue?vue&type=script&lang=js"
export * from "./WholesaleCustomerInfo.vue?vue&type=script&lang=js"
import style0 from "./WholesaleCustomerInfo.vue?vue&type=style&index=0&id=401ddfe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401ddfe9",
  null
  
)

export default component.exports